import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Card } from '@altermaind/web/ui';
import { Avatars, useRecognition } from '../../state';
import { AvatarAltermaind, AvatarStatic3D } from '../Avatars';
import { Controls } from '../Controls';
import { WrapperConversation } from '../WrapperConversation';
import { Chat } from './Chat';

type Props = {
  currentAvatar: Avatars;
};

export const Conversation: FC<Props> = ({ currentAvatar }) => {
  const {
    isCameraOn,
    startRecognition,
    stopRecognition,
    speaking,
    setEndCall,
    setIsCameraOn,
    handleVideoClick,
    streamRef,
    initClient,
    chat,
    videoRef,
  } = useRecognition();

  const { state } = useLocation();

  useEffect(() => {
    initClient(state?.initialPrompt || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <WrapperConversation>
      <Box
        pt='l'
        px='huge'
        display='flex'
        justifyContent='center'
        alignItems='center'
        height='100%'
      >
        <Box flex='1' textAlign='center'>
          <Chat text={chat} />
        </Box>
        <Box flex='2' textAlign='center'>
          <Card
            height='400px'
            p='none'
            display='flex'
            alignItems='center'
            justifyContent='center'
            position='relative'
            textAlign='center'
            maxWidth='800px'
            style={{ margin: '0 auto' }}
          >
            {isCameraOn && (
              <video
                ref={videoRef}
                autoPlay
                muted
                playsInline
                style={{
                  width: '200px',
                  height: '100px',
                  objectFit: 'cover',
                  position: 'absolute',
                  bottom: '10px',
                  left: '10px',
                  zIndex: 1000,
                  transform: 'scaleX(-1)',
                  borderRadius: '20px',
                }}
              />
            )}
            {currentAvatar === Avatars.ALTERMAIND && <AvatarAltermaind speaking={speaking} />}
            {currentAvatar === Avatars.AVATAR3D && <AvatarStatic3D speaking={speaking} />}
          </Card>
        </Box>
      </Box>
      <Box px='huge' mt='s' display='flex'>
        <Box flex='1' />
        <Box flex='2' display='flex' justifyContent='center'>
          <Controls
            startRecognition={startRecognition}
            stopRecognition={stopRecognition}
            setEndCall={setEndCall}
            speaking={speaking}
            setIsCameraOn={setIsCameraOn}
            handleVideoClick={handleVideoClick}
            isCameraOn={isCameraOn}
            streamRef={streamRef}
            vertical={false}
          />
        </Box>
      </Box>
    </WrapperConversation>
  );
};
